import { useMutation } from '@apollo/client';

import * as Types from '@xing-com/crate-common-graphql-types';
import {
  DreamInternalProfileVisitDocument,
  type DreamInternalProfileVisitMutation,
  type DreamInternalProfileVisitMutationVariables,
} from '@xing-com/crate-dream-machine-graphql';

type UseVompReturnType = {
  callVomp: (
    userId: string,
    similiarMembersVompWhitelist?: string[]
  ) => Promise<void>;
};

export const useVomp = (): UseVompReturnType => {
  const [mutateVomp] = useMutation<
    DreamInternalProfileVisitMutation,
    DreamInternalProfileVisitMutationVariables
  >(DreamInternalProfileVisitDocument);

  const callVomp = async (
    userId: string,
    similiarMembersVompWhitelist?: string[]
  ): Promise<void> => {
    // check if it's whitelisted
    if (similiarMembersVompWhitelist?.includes(userId) === false) {
      return;
    }

    mutateVomp({
      variables: {
        visiteeId: userId,
        referer: window.location.origin + window.location.pathname,
        clickReason: Types.ClickReasonsEnum.CrWebDreamMachineSearchSwipeView,
      },
    });
  };

  return { callVomp };
};
